/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_ax_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Locking a driver or constructor tells Apex Team to build every candidate lineup around that pick instead of searching all 697,680 combinations freely. The optimizer then fills the remaining budget with whichever drivers and constructors produce the highest projected points alongside your locks.`)
};

const es_f1_ax_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Bloquear un piloto o constructor le indica a Apex Team que construya cada alineación candidata alrededor de ese pick, en lugar de buscar libremente entre las 697.680 combinaciones. El optimizador luego completa el presupuesto restante con los pilotos y constructores que producen los puntos previstos más altos junto a tus selecciones bloqueadas.`)
};

const de_f1_ax_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Wenn du einen Fahrer oder Konstrukteur sperrst, baut Apex-Team jede mögliche Aufstellung um diesen Pick herum auf, statt frei alle 697.680 Kombinationen zu durchsuchen. Der Optimizer füllt das restliche Budget dann mit den Fahrern und Konstrukteuren, die zusammen mit deinen gesperrten Picks die höchsten prognostizierten Punkte ergeben.`)
};

const nl_f1_ax_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Door een coureur of constructeur te vergrendelen, bouwt Apex Team elke kandidaat-opstelling rond die pick op, in plaats van vrijelijk alle 697.680 combinaties te doorzoeken. De optimizer vult het resterende budget vervolgens aan met de coureurs en constructeurs die naast je vergrendelde picks de hoogste verwachte punten opleveren.`)
};

const fr_f1_ax_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. Verrouiller un pilote ou un constructeur indique à Équipe Apex de construire chaque composition candidate autour de ce choix, au lieu d'explorer librement les 697 680 combinaisons. L'optimiseur remplit ensuite le budget restant avec les pilotes et constructeurs qui produisent le plus de points prédits aux côtés de vos choix verrouillés.`)
};

const it_f1_ax_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Bloccare un pilota o un costruttore dice a Team Apex di costruire ogni formazione candidata intorno a quella scelta, invece di cercare liberamente tra tutte le 697.680 combinazioni. L'ottimizzatore riempie poi il budget rimanente con i piloti e i costruttori che, insieme alle tue scelte bloccate, generano i punti previsti più alti.`)
};

const pt_br2_f1_ax_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Fixar um piloto ou construtor diz à Equipe Apex para montar cada escalação candidata em torno dessa escolha, em vez de buscar livremente entre as 697.680 combinações. O otimizador então preenche o orçamento restante com os pilotos e construtores que produzem os pontos projetados mais altos ao lado das suas escolhas fixadas.`)
};

const pt_f1_ax_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Bloquear um piloto ou construtor diz ao Apex Team para construir todas as formações candidatas à volta dessa escolha, em vez de pesquisar livremente todas as 697.680 combinações. O otimizador preenche depois o orçamento restante com os pilotos e construtores que, junto das suas escolhas bloqueadas, produzem os pontos previstos mais altos.`)
};

const ja_f1_ax_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、可能です。ドライバーやコンストラクターをロックすると、Apexチームは697,680通りの組み合わせを自由に検索するのではなく、そのピックを軸にすべての候補ラインナップを構築します。残りの予算は、ロックしたピックと組み合わせたときに予測ポイントが最も高くなるドライバーとコンストラクターで埋められます。`)
};

const zh_f1_ax_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。锁定一位车手或一支车队，会让 Apex Team 围绕这个选择来构建每一个候选阵容，而不是在全部 697,680 种组合中自由搜索。优化器随后会用剩余预算，搭配预测积分最高的车手和车队来补全你的阵容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_ax_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_ax_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_ax_faq2_a", locale)
	if (locale === "en") return en_f1_ax_faq2_a(inputs)
	if (locale === "es") return es_f1_ax_faq2_a(inputs)
	if (locale === "de") return de_f1_ax_faq2_a(inputs)
	if (locale === "nl") return nl_f1_ax_faq2_a(inputs)
	if (locale === "fr") return fr_f1_ax_faq2_a(inputs)
	if (locale === "it") return it_f1_ax_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_f1_ax_faq2_a(inputs)
	if (locale === "pt") return pt_f1_ax_faq2_a(inputs)
	if (locale === "ja") return ja_f1_ax_faq2_a(inputs)
	return zh_f1_ax_faq2_a(inputs)
};